import { COUPON_CODES } from '../../constants';
import type { CouponConfigMetadata } from '../interface';

export const porkbunMetadata: CouponConfigMetadata = {
    coupons: [COUPON_CODES.PORKBUN],
    hidden: true,
};
